class MFRCollectionsFilter {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      grid: ".product-grid",
      loadMoreButton: ".product-grid__load-more a.button",
      reset: "[data-reset]",
    };

    this.init();
  }

  init() {
    this.$form = this.$element;
    this.$grid = $(`${this.selectors.grid}`);
    this.$reset = this.$element.find(this.selectors.reset);

    this.$element.on("submit", this.__handleFormSubmit.bind(this));
    this.$reset.on("click", this.__handleReset.bind(this));
    $(document).on("click", this.selectors.loadMoreButton, (e) => {
      e.preventDefault();
      const button = $(e.currentTarget);
      this.$grid.addClass("loading");

      this.getFilteredProducts(button.attr("href")).then((res, rej) => {
        this.$grid.find(".product-grid__load-more").remove();
        this.$grid.append(res.html());

        if (yotpo && yotpo.initWidgets) yotpo.initWidgets();
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

        /* TODO: Insert post-loading state */
        this.$grid.removeClass("loading");
      });
    });

    this.initSwymFunction();
  }

  initSwymFunction() {
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push((swat) => {
      // your API calls go here
      document.addEventListener("swym:collections-loaded", function () {
        swat.initializeActionButtons(".product-grid");
      });
    });
  }

  __handleFormSubmit(e) {
    e.preventDefault();
    this.$grid.addClass("loading");

    const results = this.getFilteredProducts().then((res, rej) => {
      this.$grid.html(res.html());

      if (yotpo && yotpo.initWidgets) yotpo.initWidgets();

      /* TODO: Insert post-loading state */
      this.$grid.removeClass("loading");
    });
  }

  __handleReset(e) {
    e.preventDefault();
    this.$grid.addClass("loading");

    this.$element.find("input").prop("checked", false);
    this.$element.find("input[data-default]").prop("checked", "checked");

    this.$element.submit();
  }

  getFilteredProducts(pageURL) {
    const actionUrl = this.$form.attr("action");
    const values = this.$form.serialize();
    return new Promise((res, rej) => {
      $.ajax({
        type: "GET",
        url: pageURL ?? actionUrl,
        data: values, // serializes the form's elements.
        success: function (data) {
          const grid = $(data).find(".product-grid");

          if (!pageURL) {
            var hash = values.replace(/&/g, "&");
            history.pushState({ formData: values }, "", "?" + hash);
          }

          res(grid);
        },
      });
    });
  }
}
